import React from 'react';
import { I18n } from '@aws-amplify/core';
import type { TextAreaProps } from 'antd/lib/input';
import * as S from './styles';

export default function Textarea({ placeholder = '', ...props }: Readonly<TextAreaProps>): JSX.Element {
	return <S.TextAreaWrapper {...props} placeholder={I18n.get(placeholder)} />;
}
